import React from "react";
import { createBrowserRouter, 
  RouterProvider } from "react-router-dom";

import "@aws-amplify/ui-react/styles.css";

import HomePage from "./pages/HomePage";
import GalleryPage from "./pages/GalleryPage";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePage />
    },
    {
      path: "/gallery/:folder",
      element: <GalleryPage />
    }
  ])
  
  return (
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
}
export default App;